export const authKeys = {
  all: [{ module: 'auth' }] as const,
  me: () => [{ ...authKeys.all[0], scope: 'me' }] as const,
  desktopMe: () => [{ ...authKeys.all[0], scope: 'desktopMe' }] as const,
};
